module.exports = __webpack_public_path__ + "static/media/4th.a88a72ec.png";